<style>
    .v-event-booking-panel .dropdown-events {
        position: absolute;
        z-index: 9999;
        width: 50%;
        right: 5px;
    }

    .v-event-booking-panel .dropdown-events .list-group-item:hover {
        background-color: #337ab7;
        color:#ffffff;
    }
</style>

<template>
    <div class="animated fadeIn v-event-booking-panel">

        <Request
                ref="requestDate"
                :onRequestSuccess="onRequestDateSuccess"
                root="/event-booking-panel/date">
            <slot slot="body">
                <b-row>
                    <b-col>
                        <b-card>
                            <b-row>
                                <b-col sm="12" md="6" lg="6">
                                    <b-button @click="onTodayClick" variant="action" class="pull-left btn-square"><i class="fa fa-reply"></i> {{Core.Definition.getDefinition('Auj.')}}</b-button>
                                    <InputDatePicker
                                            class="pull-left"
                                            id="datePicker"
                                            :isInline="false"
                                            v-model="dataDatePicker"></InputDatePicker>
                                </b-col>
                                <b-col class="text-right" sm="12" md="6" lg="6">
                                </b-col>
                            </b-row>
                            <b-row>
                                <b-col>
                                    <DatePagination ref="datePagination" v-model="dataDate"></DatePagination>
                                </b-col>
                            </b-row>
                        </b-card>
                    </b-col>
                </b-row>

                <div v-show="dataEventDate !== false">

                    <b-row v-if="Core.Session.AuthUser.can('event_booking_management_post_book')">
                        <b-col class="text-right">
                            <b-button v-if="" @click="onMultipleUserBookingClick" class="btn btn-sm btn-light"><i class="fa fa-plus mr-2"></i>{{Core.Definition.getDefinition('Nouvelles Réservations')}}</b-button>
                        </b-col>
                    </b-row>
                    <b-row class="mt-4">
                        <b-col>
                            <b-card :class="{'card-accent-cancelled' : dataEventDate.status === Mantle.Event.statusCancelled}">
                                <b-row>
                                    <b-col lg="4" sm="12">
                                        <h4>{{dataEventDate.title}}</h4>
                                        <b-badge v-if="dataEventDate.status === Mantle.Event.statusCancelled" class="m-1" variant="danger">{{Core.Definition.getDefinition('Annulé')}}</b-badge>
                                        <b-badge v-if="dataEventDate.status === Mantle.Event.statusDraft" class="m-1" variant="danger">{{Core.Definition.getDefinition('Brouillon')}}</b-badge>
                                        <b-badge v-if="dataEventDate.status !== Mantle.Event.statusDraft && dataEventDate.status !== Mantle.Event.statusCancelled" class="m-1" variant="active">{{Core.Date.readableTimeline(dataEventDate.start, dataEventDate.end)}}</b-badge>
                                    </b-col>
                                    <b-col class="text-center" lg="4" sm="12">
                                        <h4>{{Core.Date.readableTimes(dataEventDate.start, dataEventDate.end)}}</h4>
                                        <small class="text-muted">
                                            {{Core.Date.readableDate(dataEventDate.start)}}
                                        </small>
                                    </b-col>
                                    <b-col class="text-right" lg="4" sm="12">
                                        <b-button-group>
                                            <b-button ref="btnShowDropdownEvents" @click="dataEventDateSelector = !dataEventDateSelector" variant="modal"><i class="fa fa-list"></i></b-button>
                                            <b-button @click="selectPrevEventDate" variant="action"><i class="fa fa-chevron-left"></i></b-button>
                                            <b-button @click="selectNextEventDate" variant="action"><i class="fa fa-chevron-right"></i></b-button>
                                        </b-button-group>
                                    </b-col>
                                </b-row>

                                <div ref="dropdownEvents" class="dropdown-events">
                                        <b-list-group class="animated slide-fade-enter" v-if="dataEventDateSelector">
                                            <b-list-group-item><strong>{{Core.Definition.getDefinition('Liste des événements')}}</strong></b-list-group-item>
                                            <b-list-group-item
                                                    v-for="eventDate, eventDateIndex in dataEventDates"
                                                    :key="eventDateIndex"
                                                    @click="selectEventDate(eventDateIndex)"
                                                    :class="{'align-items-start':eventDateIndex===0}"
                                                    class="d-flex cursor-pointer">
                                                <div class="d-flex w-100 justify-content-between">
                                                    <div>{{Core.Date.readableDate(eventDate.start, 'HH:mm')}} - {{Core.Date.readableDate(eventDate.end, 'HH:mm')}}</div>
                                                    <h6 style="width: 200px;" class="mb-2">{{eventDate.title}}</h6>
                                                </div>
                                                <p class="mb-1"></p>
                                            </b-list-group-item>
                                        </b-list-group>
                                </div>
                            </b-card>
                        </b-col>
                    </b-row>

                    <b-row>
                        <b-col lg="9">
                            <Request
                                    ref="requestEvent"
                                    :onRequestSuccess="onRequestEventSuccess"
                                    root="/event-booking-panel/event">
                                <slot slot="body">

                                    <b-card no-body>
                                        <div v-b-toggle.searchForm slot="header">
                                            {{Core.Definition.getDefinition('Recherche')}}
                                            <div class="card-header-actions">
                                                <b-link class="card-header-action btn-minimize">
                                                    <i class="fa fa-chevron-down"></i>
                                                </b-link>
                                            </div>
                                        </div>

                                        <b-collapse id="searchForm">
                                            <b-card-body>
                                                <b-row>
                                                    <b-col>
                                                        <InputText
                                                                ref="id"
                                                                :label="Core.Definition.getDefinition('ID')"
                                                                v-model="dataSearch.userId"></InputText>
                                                    </b-col>
                                                    <b-col>
                                                        <InputText
                                                                ref="firstname"
                                                                :label="Core.Definition.getDefinition('Prénom')"
                                                                v-model="dataSearch.userFirstname"></InputText>
                                                    </b-col>
                                                    <b-col>
                                                        <InputText
                                                                ref="lastname"
                                                                :label="Core.Definition.getDefinition('Nom de famille')"
                                                                v-model="dataSearch.userLastname"></InputText>
                                                    </b-col>
                                                </b-row>
                                                <b-row>
                                                    <b-col>
                                                        <InputText
                                                                ref="email"
                                                                :label="Core.Definition.getDefinition('Courriel')"
                                                                v-model="dataSearch.userEmail"></InputText>
                                                    </b-col>
                                                    <b-col>
                                                        <InputPhone
                                                                ref="phone"
                                                                :label="Core.Definition.getDefinition('Téléphone')"
                                                                v-model="dataSearch.userPhone"></InputPhone>
                                                    </b-col>
                                                    <b-col>
                                                        <InputPhone
                                                                ref="mobile"
                                                                :label="Core.Definition.getDefinition('Mobile')"
                                                                v-model="dataSearch.userMobile"></InputPhone>
                                                    </b-col>
                                                </b-row>
                                                <b-row>
                                                    <b-col class="text-right">
                                                        <b-button-group class="btn-group-sm">
                                                            <b-button @click="onResetSearchClick" class="btn btn-light">{{Core.Definition.getDefinition('Réinitialiser')}}</b-button>
                                                            <b-button @click="onSearchClick" class="btn btn-info">{{Core.Definition.getDefinition('Rechercher')}}</b-button>
                                                        </b-button-group>
                                                    </b-col>
                                                </b-row>
                                            </b-card-body>
                                        </b-collapse>
                                    </b-card>

                                    <b-card>
                                        <div slot="header">
                                            {{Core.Definition.getDefinition('Participants')}}
                                            <b-badge class="m-1"  :class="{ 'badge-danger' : bookingQuantityParticipants >= dataEventDate.max, 'badge-success' : bookingQuantityParticipants < dataEventDate.max }" v-html="Mantle.Event.readableCount(bookingQuantityParticipants, dataEventDate.max)"></b-badge>
                                            <div class="card-header-actions">
                                                <UserAction ref="userActionParticipant"
                                                            v-if="Core.Session.AuthUser.can('event_booking_management_post_book')"
                                                            v-model="dataUserParticipant"
                                                            :options="{ reset: { display: false }, add: {display: true}  }">
                                                </UserAction>
                                            </div>
                                        </div>

                                        <b-row>
                                            <b-col>
                                                <div v-if="hasParticipants" class="list-group">
                                                    <EventBooking :key="'participant' + bookingIndex" @onChange="onBookingChange" v-for="booking, bookingIndex in filterParticipants" :booking="booking" :eventDate="dataEventDate" :userActiveProducts="userActiveProducts(booking.userId)"></EventBooking>
                                                </div>
                                                <b-alert v-else show variant="light">
                                                    {{Core.Definition.getDefinition('Aucun participant pour cet événement.')}}
                                                </b-alert>
                                            </b-col>
                                        </b-row>

                                    </b-card>

                                    <b-card>
                                        <div slot="header">
                                            {{Core.Definition.getDefinition('En attente')}}
                                            <b-badge class="m-1" variant="warning">{{bookingQuantityWaiting}}</b-badge>
                                            <div class="card-header-actions">
                                                <UserAction ref="userActionWaiting"
                                                            v-if="Core.Session.AuthUser.can('event_booking_management_post_book')"
                                                            :options="{ reset: { display: false }, add: { display: true }  }">
                                                </UserAction>
                                            </div>
                                        </div>

                                        <div v-if="hasBookings(Mantle.EventDateBooking.statusWaiting)" class="list-group">
                                            <EventBooking :key="'waiting' + bookingIndex"  v-for="booking, bookingIndex in filterWaiting" :eventDate="dataEventDate" :booking="booking" :userActiveProducts="userActiveProducts(booking.userId)"></EventBooking>
                                        </div>
                                        <b-alert v-else show variant="light">
                                            {{Core.Definition.getDefinition('Aucun participant en attente pour cet événement.')}}
                                        </b-alert>

                                    </b-card>

                                    <b-card>
                                        <div slot="header">
                                            {{Core.Definition.getDefinition('Annulations')}}
                                            <b-badge class="m-1" variant="danger">{{bookingQuantityCancelled}}</b-badge>
                                        </div>

                                        <div v-if="hasBookings(Mantle.EventDateBooking.statusCancelled)" class="list-group">
                                            <EventBooking :key="'cancelled' + bookingIndex" v-for="booking, bookingIndex in filterCancelled" :booking="booking" :userActiveProducts="userActiveProducts(booking.userId)"></EventBooking>
                                        </div>
                                        <b-alert v-else show variant="light">
                                            {{Core.Definition.getDefinition('Aucune annulation pour cet événement.')}}
                                        </b-alert>

                                    </b-card>

                                    <b-card v-if="Core.Session.AuthUser.can('event_booking_management_get_message')||Core.Session.AuthUser.can('event_booking_management_post_message')">
                                        <div slot="header">
                                            {{Core.Definition.getDefinition('Message')}}
                                            <div class="card-header-actions">
                                                <b-link v-if="Core.Session.AuthUser.can('event_booking_management_post_message')" @click="onNewEventMessageClick" href="#" class="card-header-action btn-setting">
                                                    <i class="fa fa-plus"></i>&nbsp;{{Core.Definition.getDefinition('Message')}}
                                                </b-link>
                                            </div>
                                        </div>
                                        <div v-if="dataEventMessages.length > 0">

                                            <div v-for="eventMessage in dataEventMessages">
                                                <div class="message">
                                                    <div>
                                                        <small v-if="eventMessage.isPublic==1" class="text-muted"><i class="fa fa-eye mr-1"></i>{{Core.Definition.getDefinition('Visible pour le public')}}</small>
                                                        <small v-if="eventMessage.isPublic==0" class="text-muted"><i class="fa fa-eye-slash mr-1"></i>{{Core.Definition.getDefinition('Invisible pour le public')}}</small>
                                                        <b-button @click="onEventDateMessageEditClick(eventMessage.id)" class="btn btn-sm btn-edit pull-right mr-2"><i class="fa fa-pencil"></i></b-button>
                                                        <small class="text-muted float-right mt-1 mr-3">{{Core.Date.readableDate(eventMessage.date)}}</small>
                                                    </div>
                                                    <div class="text-truncate font-weight-bold mt-2 mb-2">{{eventMessage.message}}</div>
                                                    <small class="text-muted"><i class="fa fa-envelope-o mr-1"></i> <span class="hidden-80">{{eventMessage.eventDateMessageUsers}}</span></small><br/>
                                                </div>
                                                <hr/>
                                            </div>

                                        </div>
                                        <b-alert v-else show variant="light">
                                            {{Core.Definition.getDefinition('Aucune message pour cet événement.')}}
                                        </b-alert>
                                    </b-card>
                                </slot>
                            </Request>

                        </b-col>
                        <b-col lg="3">
                            <b-card v-if="dataEventDate.isVirtual == 1">
                                <div slot="header">
                                    {{Core.Definition.getDefinition('Salle virtuelle')}}
                                </div>
                                <b-button @click="$router.push(Core.Text.format(Core.Definition.getDefinition('/evenement/salles-virtuelles/{0}'), dataEventDate.id))" variant="light"><i class="fa fa-video-camera mr-1"></i> {{Core.Definition.getDefinition('Rejoindre la salle virtuelle')}}</b-button>
                            </b-card>

                            <b-card>
                                <div slot="header">
                                    {{Core.Definition.getDefinition('Informations de l\'événement')}}
                                </div>
                                <div class="mb-3">
                                    <strong>{{Core.Definition.getDefinition('Responsables')}}</strong><br/>  {{Core.Text.readable(dataEventDate.eventDateUsers)}}
                                </div>
                                <div class="mb-3">
                                    <strong>{{Core.Definition.getDefinition('Local')}}</strong><br/> {{Core.Text.readable(dataEventDate.place)}}
                                </div>
                                <div class="mb-3">
                                    <strong>{{Core.Definition.getDefinition('Min / Max')}}</strong><br/> <span v-html="Mantle.Event.readableMinMax(dataEventDate.min, dataEventDate.max)"></span>
                                </div>
                                <div class="mb-3">
                                    <strong>{{Core.Definition.getDefinition('Produits requis')}}</strong><br/>
                                    <ul v-if="dataEventDate.eventDateProducts">
                                        <li v-for="eventDateProduct in dataEventDate.eventDateProducts.split('|')">
                                            {{eventDateProduct}}
                                        </li>
                                    </ul>
                                </div>
                                <div slot="footer">
                                    <b-button-group v-if="Core.Session.AuthUser.can('event_booking_management_cancel_event')">
                                        <b-button v-if="dataEventDate.status !== Mantle.Event.statusCancelled" @click="onCancelEventClick" variant="danger"><i class="fa fa-close"></i> {{Core.Definition.getDefinition('Annuler')}}</b-button>
                                    </b-button-group>
                                </div>
                            </b-card>
                        </b-col>
                    </b-row>
                </div>
                <div v-show="dataEventDates.length <= 0">
                    <b-alert show variant="light">
                        {{Core.Definition.getDefinition('Aucun événement à afficher.')}}<br/>
                    </b-alert>
                    <b-button v-if="Core.Session.AuthUser.can('event_calendar_management_get')" @click="onEventCalendarClick" class="btn btn-edit mt-3">{{Core.Definition.getDefinition('Modifier le calendrier')}}</b-button>
                </div>
            </slot>
        </Request>

        <Modal
            ref="modalCancelEvent"
            :caption="Core.Definition.getDefinition('Annuler l\'événement')"
            :okTitle="Core.Definition.getDefinition('Annuler')"
            :closeOnOk="false"
            okVariant="danger"
            @onOk="onOkCancelEvent">
            <slot slot="body">
                <Request
                        method="PUT"
                        ref="requestCancelEvent"
                        :onRequestSuccess="onRequestCancelEventSuccess"
                        root="/event-date/cancel">
                    <slot slot="body">
                        <p>
                            {{Core.Definition.getDefinition('Êtes-vous sûr de vouloir annuler cet événement? Les participants seront informés automatiquement.')}}
                        </p>
                    </slot>
                </Request>
            </slot>
        </Modal>

        <ModalEventMessage
                ref="modalEventMessage"
                @onInit="onInitEventMessage"
                @onSave="onSaveEventMessage"
                @onSaveSuccess="onSaveSuccessEventMessage">
        </ModalEventMessage>

        <ModalMultipleUserBooking
            ref="modalMultipleUserBooking"
            @onMultipleUserBookingSuccess="onMultipleUserBookingSuccess"
            :caption="Core.Definition.getDefinition('Nouvelles Réservations')">
        </ModalMultipleUserBooking>

    </div>
</template>

<script>
    import Vue from 'vue'

    Vue.use(require('vue-moment'))
    import Request from '../../components/Request'
    import Modal from '../../components/Modal'
    import ModalEventMessage from '../../components/ModalEventMessage'
    import UserAction from '../../components/UserAction'
    import DatePagination from '../../components/DatePagination'
    import InputDatePicker from '../../components/InputDatePicker'
    import InputText from '../../components/InputText'
    import InputPhone from '../../components/InputPhone'
    import InputQuantity from '../../components/InputQuantity'
    import EventBooking from '../../components/EventBooking'
    import ModalMultipleUserBooking from '../../components/ModalMultipleUserBooking'

    export default {
        name: 'EventBookingPanel',
        components: {
            Request,
            InputDatePicker,
            DatePagination,
            InputQuantity,
            EventBooking,
            UserAction,
            InputText,
            InputPhone,
            Modal,
            ModalEventMessage,
            ModalMultipleUserBooking
        },
        watch: {
            dataUserParticipant(val) {
                this.addParticipant(val)
            },
            dataUserWaiting(val) {
                this.addParticipant(val)
            },
            dataEventDate(val) {
                if (val !== undefined && Core.Validation.isId(val.id)) {
                    this.requestEventDate(val.id)
                }
            },
            dataDate(val) {
                this.requestDate(val)
                this.dataDatePicker = Core.Value.encode(val, 'datePicker')
            },
            dataDatePicker(val) {
                val = Core.Value.decode(val, 'datePicker')
                this.dataDate = val
            }
        },
        mounted() {

            if(this.$route.params.date !== undefined) {
                this.dataDate = this.$route.params.date
            }

            if(this.$route.params.eventDateId !== undefined) {
                this.dataEventDateId = this.$route.params.eventDateId
            }

            this.requestDate(this.dataDate)

            var _self = this
            document.addEventListener('click', function (e) {
                let el1 = _self.$refs.dropdownEvents
                if (undefined !== el1) {
                    let target = e.target
                    if (el1 !== target && !el1.contains(target)) {
                        let el3 = _self.$refs.btnShowDropdownEvents
                        if (el3 !== target && !el3.contains(target)) {
                            _self.dataEventDateSelector = false
                        }
                    }
                }
            })

        },
        data: function () {
            return {
                Core: window.Core,
                Mantle: window.Mantle,
                dataUserParticipant: {},
                dataUserWaiting: {},
                dataDatePicker: new Date(),
                dataDate: Vue.moment().format('YYYY-MM-DD'),
                dataNewParticipants: {
                    modal: {
                        show: false
                    }
                },
                dataEventDates: [],
                dataBookings: [],
                dataActivePurchases: [],
                dataEventMessages: [],
                dataEventDate: false,
                dataEventDateId: '',
                dataEventDateIndex: null,
                dataEventDateSelector: false,
                dataSearch: {
                    userId:'',
                    userLastname: '',
                    userFirstname:'',
                    userEmail: '',
                    userPhone: '',
                    userMobile: ''
                }
            }
        },
        computed: {
            bookingQuantityParticipants() {
                let quantity = 0
                for (let booking in this.dataBookings) {
                    booking = this.dataBookings[booking]
                    if (booking.status === Mantle.EventDateBooking.statusRegistered || booking.status === Mantle.EventDateBooking.statusPresent || booking.status === Mantle.EventDateBooking.statusAWNR || booking.status === Mantle.EventDateBooking.statusAWR) {
                        quantity = quantity + parseInt(booking.quantity)
                    }
                }
                return quantity
            },
            bookingQuantityWaiting() {
                let quantity = 0
                for (let booking in this.dataBookings) {
                    booking = this.dataBookings[booking]
                    if (booking.status === Mantle.EventDateBooking.statusWaiting) {
                        quantity = quantity + parseInt(booking.quantity)
                    }
                }
                return quantity
            },
            bookingQuantityCancelled() {
                let quantity = 0
                for (let booking in this.dataBookings) {
                    booking = this.dataBookings[booking]
                    if (booking.status === Mantle.EventDateBooking.statusCancelled) {
                        quantity = quantity + parseInt(booking.quantity)
                    }
                }
                return quantity
            },
            hasParticipants() {
                for (let booking in this.dataBookings) {
                    booking = this.dataBookings[booking]
                    if (booking.status === Mantle.EventDateBooking.statusRegistered || booking.status === Mantle.EventDateBooking.statusPresent || booking.status === Mantle.EventDateBooking.statusAWNR || booking.status === Mantle.EventDateBooking.statusAWR) {
                        return true
                    }
                }
            },
            filterParticipants() {
                let bookings = []
                for (let booking in this.dataBookings) {
                    booking = this.dataBookings[booking]
                    if (booking.status === Mantle.EventDateBooking.statusRegistered || booking.status === Mantle.EventDateBooking.statusPresent || booking.status === Mantle.EventDateBooking.statusAWNR || booking.status === Mantle.EventDateBooking.statusAWR) {
                        bookings.push(booking)
                    }
                }
                return bookings
            },
            filterWaiting() {
                let bookings = []
                for (let booking in this.dataBookings) {
                    booking = this.dataBookings[booking]
                    if (booking.status === Mantle.EventDateBooking.statusWaiting) {
                        bookings.push(booking)
                    }
                }
                return bookings
            },
            filterCancelled() {
                let bookings = []
                for (let booking in this.dataBookings) {
                    booking = this.dataBookings[booking]
                    if (booking.status === Mantle.EventDateBooking.statusCancelled) {
                        bookings.push(booking)
                    }
                }
                return bookings
            }
        },
        methods: {
            onMultipleUserBookingClick() {
                let options = Core.Select.getOptions(this.dataEventDates, ['start', 'title'], 'id')
                this.$refs.modalMultipleUserBooking.open(options)
            },
            onMultipleUserBookingSuccess() {
                this.requestEventDate(this.dataEventDate.id)
            },
            onEventCalendarClick() {
                this.$router.push(Core.Definition.getDefinition('/evenement/calendrier'))
            },
            onCancelEventClick() {
                this.$refs.modalCancelEvent.open = true
            },
            onOkCancelEvent() {
                this.$refs.requestCancelEvent.clearArgs()
                this.$refs.requestCancelEvent.addArg('id', this.dataEventDate.id)
                this.$refs.requestCancelEvent.request()
            },
            onRequestCancelEventSuccess(data) {
                if (data.id !== undefined) {
                    this.dataEventDate.status = Mantle.Event.statusCancelled
                    this.$refs.modalCancelEvent.open = false
                }
            },
            onNewEventMessageClick() {
                this.$refs.modalEventMessage.id = ''
                this.$refs.modalEventMessage.open = true
            },
            onInitEventMessage() {
                this.$refs.modalEventMessage.$refs.dynamicForm.$refs.request.addArg('eventDateId', this.dataEventDate.id)
            },
            onSaveEventMessage() {
                this.$refs.modalEventMessage.$refs.dynamicForm.addSaveArg('eventDateId', this.dataEventDate.id)
            },
            onTrashEventMessage() {
                this.$refs.modalEventMessage.id = ''
                this.$refs.modalEventMessage.open = false
            },
            onSaveSuccessEventMessage(data) {
                this.$refs.modalEventMessage.id = ''
                this.$refs.modalEventMessage.open = false

                if (data.eventDateMessages !== undefined) {
                    this.dataEventMessages = []
                    this.dataEventMessages = data.eventDateMessages
                }
            },
            onEventDateMessageEditClick(eventDateMessageId) {
                this.$refs.modalEventMessage.id = eventDateMessageId
                this.$refs.modalEventMessage.open = true
            },
            onTodayClick() {
                this.dataDate = Vue.moment().format('YYYY-MM-DD')
            },
            hasBookings(status) {
                for (let booking in this.dataBookings) {
                    booking = this.dataBookings[booking]
                    if (booking.status === status) {
                        return true
                    }
                }
            },
            userActiveProducts(userId) {
                for (let activeProducts in this.dataActiveProducts) {
                    activeProducts = this.dataActiveProducts[activeProducts]
                    if (activeProducts.userId === userId) {
                        return activePurchases
                    }
                }
                return false
            },
            requestDate(date) {
                this.$refs.requestDate.addArg('date', date)
                this.$refs.requestDate.request()
            },
            requestEventDate(eventDateId) {
                this.$refs.requestEvent.setMethod('GET')
                this.$refs.requestEvent.setRoot('/event-booking-panel/event')
                this.$refs.requestEvent.clearArgs()
                this.$refs.requestEvent.addArg('userId', this.dataSearch.userId)
                this.$refs.requestEvent.addArg('userFirstname', this.dataSearch.userFirstname)
                this.$refs.requestEvent.addArg('userLastname', this.dataSearch.userLastname)
                this.$refs.requestEvent.addArg('userEmail', this.dataSearch.userEmail)
                this.$refs.requestEvent.addArg('userPhone', this.dataSearch.userPhone)
                this.$refs.requestEvent.addArg('userMobile', this.dataSearch.userMobile)
                this.$refs.requestEvent.addArg('eventDateId', eventDateId)
                this.$refs.requestEvent.request()
            },
            onRequestDateSuccess(data) {
                if (data.eventDates !== undefined) {
                    this.dataEventDates = data.eventDates
                    if (Core.Validation.isId(this.dataEventDateId)) {
                        let eventDateIndex = Core.Array.findIndexByKey(data.eventDates, 'id', this.dataEventDateId)
                        if (!Core.Validation.isId(this.dataEventDateId)||eventDateIndex===false) {
                            this.selectEventDate(0)
                        } else {
                            this.selectEventDate(eventDateIndex)
                        }
                        //this.dataEventDateId = 0
                    } else {
                        this.selectEventDate(0)
                    }
                }
            },
            onRequestEventSuccess(data) {
                this.dataBookings = []
                if (data.bookings !== undefined) {
                    this.dataBookings = data.bookings
                }

                this.dataActivePurchases = []
                if (data.activePurchases !== undefined) {
                    this.dataActivePurchases = data.activePurchases
                }

                this.dataEventMessages = []
                if (data.eventDateMessages !== undefined) {
                    this.dataEventMessages = data.eventDateMessages
                }
            },
            selectEventDate(eventDateIndex) {
                this.dataEventDateSelector = false
                if (this.dataEventDates[eventDateIndex] !== undefined) {
                    this.dataEventDateIndex = eventDateIndex
                    this.dataEventDate = this.dataEventDates[eventDateIndex]
                } else {
                    this.dataEventDate = false
                }
            },
            selectNextEventDate() {
                this.dataEventDateIndex ++
                if (this.dataEventDateIndex >= this.dataEventDates.length) {
                    this.dataEventDateIndex = 0
                }
                this.selectEventDate(this.dataEventDateIndex)
            },
            selectPrevEventDate() {
                this.dataEventDateIndex --
                if (this.dataEventDateIndex < 0) {
                    this.dataEventDateIndex = this.dataEventDates.length - 1
                }
                this.selectEventDate(this.dataEventDateIndex)
            },
            addParticipant(user) {
                this.$refs.requestEvent.setMethod('POST')
                this.$refs.requestEvent.setRoot('/event-booking-panel/book')
                this.$refs.requestEvent.clearArgs()
                if (Core.Validation.isId(user.id)||user.email !== ''||user.phone !== '') {
                    this.$refs.requestEvent.addArg('eventDateId', this.dataEventDate.id)
                    this.$refs.requestEvent.addArg('userId', user.id)
                    this.$refs.requestEvent.addArg('userFirstname', user.firstname)
                    this.$refs.requestEvent.addArg('userLastname', user.lastname)
                    this.$refs.requestEvent.addArg('userEmail', user.email)
                    this.$refs.requestEvent.addArg('userPhone', user.phone)
                    this.$refs.requestEvent.addArg('userMobile', user.mobile)
                    this.$refs.requestEvent.addArg('userBirthdate', Core.Value.decode(user.birthdate, Core.Value.typeDatePicker))
                    this.$refs.requestEvent.request()
                    //this.$refs.userActionParticipant.$refs.modalUser.open = false
                }
            },
            onResetSearchClick() {
                this.dataSearch = {
                    userId:'',
                    userLastname: '',
                    userFirstname:'',
                    userEmail: '',
                    userPhone: '',
                    userMobile: ''
                }
                this.requestEventDate(this.dataEventDate.id)
            },
            onSearchClick() {
                this.requestEventDate(this.dataEventDate.id)
            },
            onBookingChange(booking) {
                this.calcBookingRemaining(booking)
            },
            calcBookingRemaining(booking) {
                let bookingPurchaseType = ''
                let bookingLimit = 0

                if (Core.Validation.isId(booking.limitedSubscriptionId)) {
                    bookingPurchaseType = Core.Product.typeLimitedSubscription
                    bookingLimit = booking.limitedSubscriptionBookingLimit
                }

                if (Core.Validation.isId(booking.recurringSubscriptionId)) {
                    bookingPurchaseType = Core.Product.typeRecurringSubscription
                    bookingLimit = booking.recurringSubscriptionBookingLimit
                }

                let bookingCount = 0

                for(let bookingIndex in this.dataBookings) {
                    switch(bookingPurchaseType) {
                        case Core.Product.typeLimitedSubscription:
                            if (this.dataBookings[bookingIndex].limitedSubscriptionId === booking.limitedSubscriptionId) {
                                bookingCount += parseInt(this.dataBookings[bookingIndex].quantity)
                            }
                            break
                        case Core.Product.typeRecurringSubscription:
                            if (this.dataBookings[bookingIndex].recurringSubscriptionId === booking.limitedSubscriptionId) {
                                bookingCount += parseInt(this.dataBookings[bookingIndex].quantity)
                            }
                            break
                    }
                }

                let bookingRemaining = bookingLimit - bookingCount
                for(let bookingIndex in this.dataBookings) {
                    switch(bookingPurchaseType) {
                        case Core.Product.typeLimitedSubscription:
                            if (this.dataBookings[bookingIndex].limitedSubscriptionId === booking.limitedSubscriptionId) {
                                this.dataBookings[bookingIndex].limitedSubscriptionBookingRemaining = bookingRemaining
                            }
                            break
                        case Core.Product.typeRecurringSubscription:
                            if (this.dataBookings[bookingIndex].recurringSubscriptionId === booking.limitedSubscriptionId) {
                                this.dataBookings[bookingIndex].recurringSubscriptionBookingRemaining = bookingRemaining
                            }
                            break
                    }
                }
            }
        }
    }
</script>
